export default __webpack_public_path__ + "static/media/computer.36ae91d3.png";